export default __webpack_public_path__ + "static/media/Santi.75050ebe.jpeg";